'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import _ from 'lodash';
import formatter from './formatter';
import analytics from './analytics';

class TicketSelector {

  constructor(){
    this.catalogItemSelections = Array.from(document.querySelectorAll('.catalog-items__selection'));
    this.programItemSelections = Array.from(document.querySelectorAll('.program-items__selection'));
    this.eventsNeeded = this.catalogItemSelections.length + this.programItemSelections.length ? true : false;
    this.cartButton = document.querySelectorAll('.add-to-cart'); // actually this just moves user from ticket-selector to cart page. Items are already in cart.
    this.stageLoc = document.body.getAttribute('data-stage-loc') || 'fi';
    this.ajaxEndPoint = '/stage-ajax/cart';
    this.cart = $('#cartInit').length ? { cart: $('#cartInit').data('cart'), } : null; // get initial cart from DOM. Insert it into an object to simulate ajax response.
    this.debounceTime = 500; // milliseconds
    this.catalogItemErrorTemplate = document.getElementById('catalog-item-error');
    this.catalogItemMessageTemplate = document.getElementById('catalog-item-message');
    this.animationDuration = 200;
    this.lang = $(document.body).data('stage-loc') || 'fi';
    this.$rootEl = $('.ticket-selector');
    this.$navigationCartElements = $('.header__cart.cart, .mobile-nav__cart.cart');
    this.$cookieErrorEl = $('.ticket-selector__cookie-not-available');
  }

  /**
   * Access Cart API endpoint
   * @param {string} method - Request method [GET]
   * @param {string} action - Request action [update|add|remove|add-discount-code|remove-discount-code]
   * @param {number|int} amount - Amount of requested item
   * @param {number|int} catalogId - Item identifier
   * @returns {object} Ajax response (Cart)
   * @todo Ajax error handling
   */
  cartApi(method = 'GET', action = 'update', amount = 0, catalogId = 0) {
    const lang = this.lang;
    return $.ajax({
      url: `${this.ajaxEndPoint}/?action=${action}&amount=${amount}&catalog_id=${catalogId}&stage-language=${lang}`,
      method: method
    });
  }

  /**
   * Change triggered for a catalog item
   * @param {object} options - Catalog item options (ID and amount)
   */
  catalogItemChange(options) {
    const parent = this;
    if (options && typeof options.catalogItemId !== 'undefined' && typeof options.catalogItemAmount !== 'undefined') {
      parent.updateTicketSelectorUI(this.cart, options);
      const cartRequest = this.cartApi(
        'GET',
        'update',
        parseInt(options.catalogItemAmount),
        parseInt(options.catalogItemId)
      );
      cartRequest
        .done(function(response, textStatus) {
          parent.checkCommonErrors(response);
          parent.updateTicketSelectorUI(response, options, textStatus);
          parent.updateSummaryUI(response.cart);
          parent.updateNavigationCarts(response.cart);
          parent.checkCartActions(response.cart);
        }).fail(function(error, textStatus) {
          parent.updateTicketSelectorUI(parent.cart, options, textStatus, error);
        });
    }
  }

  /**
   * Check if response has a cart with common errors in it.
   * if it has, alert user + force page reload to refresh view
   * @param {object} response - ajax response
   * @memberof TicketSelector
   */
  checkCommonErrors(response){
    try {
      const errors = response.cart.cart.errors.common;
      let texts = [];
      if( errors && errors.length ) {
        for( const error of errors ){
          texts.push(error.text);
        }
        texts = texts.join('\n');
        alert( texts ); // This alert is here on purpose. Yes. We want to alert.
        window.location.reload(true);
      }
    }
    catch(e){
      console.error('ticket-selector: checkCommonErrors() failed');
    }
  }

  /**
   * Update single catalog item row in ticket selector
   * @param {object} response - Current cart or ajax response cart
   * @param {object} options - Catalog ID, amount and may contain ajax-related information
   * @param {string} textStatus - Ajax request status
   * @param {object} error - Ajax error object
   */
  updateTicketSelectorUI(response = this.cart, options, textStatus, error = {}) {

    const fromAjax = textStatus ? true : false; // if this method was called without ajax, then this method should only toggle CSS classes
    const $catalogItemList = $('ul.catalog-items__section-items-list');
    const $catalogItem = $('li.catalog-items__item[data-catalog-item-id="'+options.catalogItemId+'"]');
    const $selectionArea = $catalogItem.find('.catalog-items__selection');
    const $selectionElement = $selectionArea.find('select');
    const $catalogItemQuantityBtn = $catalogItemList.find('span.catalog-items__button');
    const $catalogItemQuantitySelectBtn = $catalogItemList.find('span.catalog-items__select-visible-content');
    
    $catalogItemQuantityBtn.toggleClass('disabled', true);
    $catalogItemQuantitySelectBtn.toggleClass('disabled', true);

    // Set UI in 'loading' state if method was called without textStatus
    if( !fromAjax ){
      $selectionArea.toggleClass('loading', true);
      // Note: disabled prop commented out.
      // Disable removes focus from element, which looks horrible with focus styles: drop shadow flickers.
      // If we must disable select, then this must get it's focus back (by javascript) after ajax
      // $selectionElement.prop('disabled', true);

      // do nothing else
      return;
    }

    const selectValue = Number($selectionElement.val());
    const $selectVisibleEl = $selectionArea.find('.catalog-items__select-value');

    const errorTemplate = document.getElementById('catalog-item-error').innerHTML || '{{.}}';
    const errorsEl = $catalogItem.find('.catalog-items__errors');
    const messageTemplate = document.getElementById('catalog-item-message').innerHTML || '{{.}}';
    const messagesEl = $catalogItem.find('.catalog-items__messages');

    const cartHasErrors = Object.keys(response.cart.cart.errors).length > 1 ? true : false; // there's always the 'common' key, so default length is 1
    const cartHasMessages = Object.keys(response.cart.cart.messages).length > 1 ? true : false; // there's always the 'common' key, so default length is 1

    // remove 'loading' state
    $selectionArea.toggleClass('loading', false);
    $catalogItemQuantityBtn.toggleClass('disabled', false);
    $catalogItemQuantitySelectBtn.toggleClass('disabled', false);
    // $selectionElement.prop('disabled', false);

    // Note: ajax success happens even if there are errors/messages in cart.
    if( textStatus === 'success' ){

      // update cart in this class
      this.cart = response;

      // check cart errors, write them to the page.
      if( cartHasErrors ) response.cart.cart.errors[options.catalogItemId].forEach(element => {
        const errorMarkup = Mustache.render( errorTemplate, element );
        $(errorsEl).append( errorMarkup );
      });

      // check cart messages, write them to the page.
      if( cartHasMessages ) response.cart.cart.messages[options.catalogItemId].forEach(element => {
        const messageMarkup = Mustache.render( messageTemplate, element );
        $(messagesEl).append( messageMarkup );
      });

    }
    // ajax failed!
    else {
      console.error('error', error);
      // eslint-disable-next-line no-alert
      if( error.statusText ) window.alert( error.statusText + ', code: ' + error.status );
      if( error.status === 400 ) {
        // "400 Bad request" is returned if ajax was submitted without Stage session cookie value.
        // If so, hide the ticket selector and show infotext about cookies
        this.$rootEl.children().hide();
        this.$cookieErrorEl.show();
      }
    }

    // how many cart items there are with requested catalogItemId ?
    const itemCount = response.cart.cart.cart_items.filter(function(item){
      if( item.catalog_id === '' + options.catalogItemId ) return item;
    }).length;

    // change UI to match cart item count if they do not match
    if( ~~selectValue !== itemCount ){
      // reset select
      $selectionElement.val(itemCount);
      // reset visible element
      $selectVisibleEl.text(itemCount);
      // make sure button states are up-to-date after change
      this.checkItemButtonStates($selectionArea[0]);
    }

  }

  /**
   * Extract catalog item name from DOM
   * @param {number|int} catalogId - Numeric Catalog ID
   * @returns {string} The name of the catalogId
   */
  getNameByCatalogId(catalogId = null) {
    const $catalogElement = $('li.catalog-items__item[data-catalog-item-id="'+catalogId+'"]');
    let $catalogItemName = $catalogElement.find('.catalog-items__name').clone();
    $catalogItemName.find('.description').remove();
    return $catalogItemName.text();
  }

  /**
   * Format cart object to ticket selector summary
   * @note Summary does not contain items that belongs to other than active ticket selector
   * @param {object} cart - Current cart object
   * @returns {object} Cart summary object for Mustache template
   */
  formatSummaryData(cart = this.cart) {
    let cartSummary;
    if (cart) {
      const currentCart = cart;
      const quantities = _.countBy(currentCart.cart_items, 'catalog_id');
      let items = [];
      let eventItemIds = [];
      for (const id of Object.keys(quantities)) {
        const quantity = parseInt(quantities[id]);
        const label = this.getNameByCatalogId(id);
        if (label !== '') {
          eventItemIds.push(id);
          items.push({
            id,
            quantity,
            label
          });
        }
      }
      const eventItems = _.filter(currentCart.cart_items, (item) => eventItemIds.includes(item.catalog_id));
      const euroCents = _.sumBy(eventItems, (item) => parseInt(item.price));
      const totalPrice = formatter.toEuroString(euroCents);
      const cartHasEventItems = eventItems ? !!eventItems.length : false;
      const cartHasItems = currentCart.cart_items ? !!currentCart.cart_items.length : false;
      cartSummary = {
        items,
        totalPrice,
        cartHasEventItems,
        cartHasItems
      };
    }
    return cartSummary;
  }

  /**
   * Update ticket selector's summary block based on cart content
   * @param {object} cart - Cart object
   */
  updateSummaryUI(cart = this.cart) {
    const summary = !(cart.cart.cart) ? this.formatSummaryData(cart.cart) : this.formatSummaryData(cart.cart.cart);
    const summaryTemplate = document.getElementById('ticket-selector-summary').innerHTML;
    const summaryMarkup = Mustache.render( summaryTemplate, summary);
    $('#ticket-selector-summary-placeholder').html(summaryMarkup);

    // floater
    const $floatEl = $('#ts-summary-float');
    if( $floatEl.length ){ // it may not be there if this is in external environment.
      $floatEl.attr('aria-hidden',!summary.cartHasEventItems); // toggle aria-attribute, this toggles element visibility
      let count = 0;
      for( const item of summary.items ) count += item.quantity;
      const pluralSingular = count === 1 ? 'data-text-singular' : 'data-text-plural';
      const $textEl = $floatEl.find('.text');
      const text = $textEl.attr(pluralSingular);
      $textEl.text(text);
      $floatEl.find('.count').text(count);
    }

  }

  /**
   * Update cart elements inside desktop and mobile navigation if they exist
   *
   * @param {object} [cart=this.cart] - cart object from ajax
   * @memberof TicketSelector
   */
  updateNavigationCarts(cart){
    if( !this.$navigationCartElements.length || !cart || !cart.cart || !cart.cart.cart_items ) return;
    $.each(this.$navigationCartElements,function(){
      const length = cart.cart.cart_items.length;
      const attrName = length === 1 ? 'data-text-singular' : 'data-text-plural';
      const $textEl = $(this).find(`[${attrName}]`);
      const text = $textEl.length ? $textEl.attr(attrName) : '';
      if( text ) $textEl.html(text);
      $(this).find('.header__cart-amount-number').html(length);
      $(this).find('.mobile-nav__cart-amount-number').html(length);
    });
  }

  /**
   * attach events for ticketSelector's DOM elements
   * @memberof TicketSelector
   */
  attachEvents(){
    const parent = this;

    // catalogItems selections
    // dropdown changes, 2 separate events
    // 1st event: modify UI (instantly)
    $(document.body).on('change','.catalog-items__select',function(e){
      const catalogItem = $(this).closest('.catalog-items__section');
      const catalogItemSelection = $(this).closest('.catalog-items__selection')[0] || null;
      const value = $(this).val();
      const valueEl = $(this).parent().find('.catalog-items__select-value');

      // if current item has errors/messages, hide them from ui
      $(catalogItem).find('.catalog-items__errors-item, .catalog-items__messages-item').remove();

      // change span text
      $(valueEl).text(value);

      // update button states
      parent.checkItemButtonStates(catalogItemSelection);
    });

    // Debounce click event(s) for each catalog item
    let timers = {};

    // 2nd event:
    $(document.body).on('change','.catalog-items__select', function() {
      const catalogElement = $(this).closest('.catalog-items__item');
      const catalogItemId = catalogElement.data('catalog-item-id');
      const rawAmount = $('select[name=catalog-item-' + catalogItemId + '] option:selected').val();
      const catalogItemAmount = typeof rawAmount === 'string' ? parseInt(rawAmount) : 0;
      // Clear any possible current timeouts
      clearTimeout(timers['catalog_item_' + catalogItemId]);
      
      // Set debounce timeout
      timers['catalog_item_' + catalogItemId] = setTimeout(function() {
        // Debounce timeout succesfully reached, make proper call and delete debounce timer
        parent.catalogItemChange({catalogItemId, catalogItemAmount});
        delete timers['catalog_item_' + catalogItemId];
      }, parent.debounceTime);
    });

    $(document.body).on('click', 'a#cart-link, a.ts-summary__foot-cart-btn', function(e) {
      // Prevent opening cart page instantly in case there is pending add-to-cart debounche(s)
      if (Object.keys(timers).length !== 0) {
        const primaryTargetPath = `${e.target.origin}${e.target.pathname}`;
        // eslint-disable-next-line
        const alternativeTargetPath = (e.target.parentElement.href !== undefined) ? e.target.parentElement.href : `${(e.target.baseURI).match(/^(?:\/\/|[^\/]+)*/)}${$('a#cart-link').attr('href')}`;
        let locationSet = false;
        e.preventDefault();
        let cartActions = setInterval(function(){
          if (Object.keys(timers).length === 0) {
            if (locationSet === false) {
              window.location.href = (e.target.origin !== undefined && e.target.pathname !== undefined) ? primaryTargetPath : alternativeTargetPath;
              locationSet = true;
            }
          }
        }, parent.debounceTime);
        cartActions;
        setTimeout(function() {
          clearInterval(cartActions);
          window.location.href = (e.target.origin !== undefined && e.target.pathname !== undefined) ? primaryTargetPath : alternativeTargetPath;
        }, parent.debounceTime * 4);
      }
    });

    // Catalog-items error and message boxes clicks: close box
    $(document.body).on('click','.catalog-items__errors-item, .catalog-items__messages-item',function(e){
      $(this).animate({opacity: 0},300,function(){
        $(this).slideUp(300,function(){
          $(this).remove();
        });
      });
    });

    // Click event at the bottom of the Ticket Selector: remove-from-cart
    $(document.body).on('click', 'a.remove-cart-item',function(e) {
      e.preventDefault();
      const catalogId = $(this).data('id');
      $(this).parent().addClass('loading');
      $('select[name="catalog-item-' + catalogId + '"]').val(0).trigger('change');
    });

    // Catalog-items plus and minus button clicks
    $(document.body).on('click','.catalog-items__button',function(e){

      const catalogItemSelection = $(this).closest('.catalog-items__selection')[0] || null;
      const select = catalogItemSelection ? catalogItemSelection.querySelector('select') : null;
      const valueEl = catalogItemSelection.querySelector('.catalog-items__select-value');
      const changeIndex = $(this).hasClass('button-minus') ? -1 : 1;

      if( $(this).hasClass('disabled') || $(select).is(':disabled') ) return;

      // change <select> element's value
      if( select ) {
        const value = parent.changeItemSelection( select, changeIndex );
        // write new value to span
        if( value ) valueEl.innerHTML = value;
      }

      // enable/disable buttons
      if( catalogItemSelection ) parent.checkItemButtonStates( catalogItemSelection );
    });


    // "show all" buttons under catalog items lists
    $(document.body).on('click','.catalog-items__section-item-list-toggle',function(e){
      e.preventDefault();

      const $section = $(this).closest('.catalog-items__section');
      const $items = $section.find('.catalog-items__section-items-list > li');
      const $span = $(this).find('span');
      const openText = $(this).data('text-open') || 'Show more';
      const closeText = $(this).data('text-close') || 'Show less';

      if( $(this).hasClass('open') ){
        // close list
        $(this).toggleClass('open',false);
        $($items).each(function(index){
          if( index > 2 ) $(this).slideUp(parent.animationDuration,function(){
            $(this).attr('aria-hidden','true');
          });
        });
        $span.text(openText);
      }
      else {
        // open list
        $(this).toggleClass('open',true);
        $span.text(closeText);
        const impressions = [];

        $($items).each(function(index){
          if( index > 2 ){
            $(this).hide().slideDown({
              duration: parent.animationDuration,
              start: function(){
                $(this).css({display: 'flex'});
              }
            });
            const impression = $(this).data('impression');
            if( impression ) impressions.push(impression);
          }
        });

        if( impressions.length ) analytics.pushToDataLayer(analytics.createImpressionEvent(impressions));

      } // else
    });

    // programs list

    // toggle programs list
    $(document.body).on('click','.catalog-items__group-toggle .toggler',function(event){

      event.preventDefault();
      const section = $(this).closest('.catalog-items__section-items-list');
      const groups = $(section).find('.catalog-items__group');
      const group = $(this).closest('.catalog-items__group');
      const items = group && group.length ? $(group).find('[data-impression]') : null;

      const href = $(this).attr('href');
      const contents = $(href);
      const textEl = $(this).find('.text');
      const openTxt = $(this).data('txt-open');
      const closeTxt = $(this).data('txt-close');

      // close group
      if( group.hasClass('open') ){
        $(this).toggleClass('open',false);
        $(contents).slideUp(parent.animationDuration,function(){
          $(this).attr('aria-hidden','true');
        });
        $(group).toggleClass('open',false);
        $(textEl).text(openTxt);
      }
      // open group
      else {
        $(this).toggleClass('open',true);
        $(contents).hide().attr('aria-hidden','false').slideDown(parent.animationDuration);
        $(group).toggleClass('open',true);
        $(textEl).text(closeTxt);

        // eCommerce: add product impressions
        if( items && items.length ){
          const impressions = [];

          $(items).each(function(index){
            const impression = $(this).data('impression');
            if( impression ) impressions.push(impression);
          });

          if( impressions.length ) analytics.pushToDataLayer(analytics.createImpressionEvent(impressions));
        }

      } // else

      // toggle section class based on if any of it's groups is open
      $(section).toggleClass('groups-open',($(groups).filter(function(item){return $(this).hasClass('open')}).length ? true : false ));


    });

    // floater-bar's link to ticket-selector summary
    $(document).on('click','.ts-summary-float__link a',function(e){
      e.preventDefault();
      const pos = $('#ts-summary').offset().top || 0;
      const offset = $('#ts-summary-float').height() || 0;
      const target = pos - offset;
      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, 300);
    });

  } // attachEvents()


  /**
   * set 'loading' state of catalog item while ajax is running
   * @param {object} selectEl - <select> element of catalog item
   * @param {boolean} [state=false] - enable/disable state. True starts loading animation and disables buttons and select. false = vice versa
   * @memberof TicketSelector
   */
  catalogItemLoading(selectEl,state = false){
    const $wrapEl = $(selectEl).closest('.catalog-items__selection');
    $wrapEl.toggleClass('loading',state);
  }

  /**
   * set ticket selector's "add to cart" button to disabled/enabled state
   *
   * @param {Boolean} state - true: enable, false: disable
   * @memberof TicketSelector
   */
  toggleCartButton(state){
    if( !this.cartButton ) return;

    this.cartButton.classList.toggle('disabled',state);
    if( this.cartButton.classList.contains('disabled') ){
      this.cartButton.disabled = true;
    }
    else {
      this.cartButton.disabled = false;
    }
  }

  /**
   * Change <select> element's option to next or previous if it's available
   *
   * @param {Object} selectEl - <select> element to change
   * @param {Number|integer} delta - change in option index. Values -1 or 1
   * @returns {String} - selected option's value or empty string if value not available
   * @memberof TicketSelector
   */
  changeItemSelection(selectEl,delta){

    let retVal = '';

    const selectedIndex = selectEl.selectedIndex;
    const next = selectEl.options[selectedIndex+1] || null;
    const prev = selectEl.options[selectedIndex-1] || null;

    if( next && delta === 1 ) {
      const option = selectEl.options[selectedIndex+1];
      option.selected = true;
      retVal = option.value || option.text;
      $(selectEl).trigger('change'); // trigger the <select> element's 'change' event to activate debounce.
    }
    else if( prev && delta === -1 ){
      const option = selectEl.options[selectedIndex-1];
      option.selected = true;
      retVal = option.value || option.text;
      $(selectEl).trigger('change'); // trigger the <select> element's 'change' event to activate debounce.
    }

    return retVal;
  }

  /**
   * enable/disable Item Selection buttons (+/-) based on <select> element's state
   * @note this only toggles 'disabled' CSS CLASS NAME, not disable property
   *
   * @param {Object} item - Item selection element that wraps <select> and button elements
   * @memberof TicketSelector
   */
  checkItemButtonStates(item){

    const select = item.querySelector('select');
    const btnMinus = item.querySelector('.button-minus');
    const btnPlus = item.querySelector('.button-plus');
    if( !select ){
      return;
    }
    const selectedIndex = select.selectedIndex || 0;
    const prev = select.options[selectedIndex-1] || null;
    const next = select.options[selectedIndex+1] || null;

    btnMinus.classList.toggle('disabled',btnMinus && !prev);
    btnPlus.classList.toggle('disabled',btnPlus && !next);
  }

  /**
   * Get performed actions from Cart and create eCom events (analytics)
   * @param {object} cart - Cart object from ajax request
   * @returns {boolean} - success value as boolean
   */
  checkCartActions( cart ){
    if( !cart || !cart.cart || !cart.cart.actions || typeof analytics === 'undefined' ) return false;
    if( !cart.cart.actions.length ) return true;
    return analytics.processCartActions(cart.cart.actions);
  }


  /**
   * sets the initial button states for ticketSelector
   * @memberof TicketSelector
   */
  initView(){
    // loop catalogItemSelections, set up buttons to match <select> element's state
    for( let item of this.catalogItemSelections ){
      this.checkItemButtonStates(item);
    }
    // loop programItemSelections, set up buttons to match <select> element's state
    for( let item of this.programItemSelections ){
      this.checkItemButtonStates(item);
    }
  }

  /**
   * Initialize TicketSelector
   */
  init() {
    console.log('ticketSelector.init()');
    if( this.eventsNeeded ){
      this.initView();
      this.attachEvents();
      this.updateSummaryUI();
    }
  }
}

export default new TicketSelector();
